enum LoginStep {
  EmailEntry = 'emailEntry',
  Registration = 'registration',
  Password = 'password',
  OtpVerification = 'otpVerification',
  ForgotPassword = 'forgotPassword',
  NewPassword = 'newPassword',
  PasswordResetSmsOtp = 'passwordResetSmsOtp',
  Waitlisted = 'waitlisted',
}

type OtpPurpose = 'registration' | 'login' | 'passwordReset';
type OtpChannel = 'sms' | 'email';

interface ILoginFlowState {
  email: string;
  userId: string | null;
  otpPurpose: OtpPurpose;
  otpChannel?: OtpChannel;
  phoneLast4?: string;
  requiresSmsOtp?: boolean;
  // Carried across the email→SMS OTP transition for the final reset-password call
  pendingEmailCode?: string;
  pendingNewPassword?: string;
}

interface ILoginStepProps {
  flowState: ILoginFlowState;
  onBack?: () => void;
}

const RESEND_COUNTDOWN_SECONDS = 60;
const OTP_CODE_LENGTH = 6;

export { LoginStep, OTP_CODE_LENGTH, RESEND_COUNTDOWN_SECONDS };
export type { ILoginFlowState, ILoginStepProps, OtpChannel, OtpPurpose };
